import React from 'react'
import Typography from '../../../Typography'
import Container from '../../../v2/Container'

const ErrorState = ({ message }) => (
  <Container maxWidth="md" padding={8}>
    <Typography align="center">{message}</Typography>
  </Container>
)

export default ErrorState
